import { $ } from '@starberry/components';
import { format } from 'date-fns';
import { ActionTitle } from 'core/helpers/actions';

const ActionDialog = {
  $: 'Modal',
  props: {
    isOpen: false,
    onClose: undefined,
    motionPreset: 'slideInBottom',
    isCentered: true,
  },
  children: (props) => [
    { $: 'ModalOverlay' },
    {
      $: 'ModalContent',
      children: [
        {
          $: 'ModalHeader',
          children: '',
        },
        {
          $: 'ModalBody',
          props: {
            padding: 50,
            textAlign: 'center',
          },
          children: [
            {
              $: 'Text',
              props: {
                fontWeight: 'bold',
                color: 'gray.600',
                fontSize: 'md',
              },
              children: props.data
                ? [
                    {
                      component: ActionTitle,
                      props: {
                        data: props.data,
                      },
                    },
                  ]
                : props.action,
            },
            {
              $: 'Text',
              props: {
                whiteSpace: 'nowrap',
                fontSize: 15,
                color: 'gray.500',
              },
              children: props.time ? format(new Date(props.time), 'dd/MM/yyyy · HH:mmaa') : '',
            },
          ],
        },
        { $: 'ModalCloseButton', props: { _focus: { boxShadow: 'none' } } },
        { $: 'ModalBody', children: $('description') },
        {
          $: 'ModalFooter',
          props: {
            justifyContent: 'center',
          },
          children: [
            {
              $: 'Button',
              props: {
                colorScheme: 'blue',
                mr: 3,
                onClick: () => props.onClose,
              },
              children: 'Accept',
            },
            {
              $: 'Button',
              props: {
                onClick: () => props.onClose,
              },
              children: 'Reject',
            },
          ],
        },
      ],
    },
  ],
};

export default ActionDialog;
